import { useState } from "react";
import FirebaseFirestoreService from "../../firebase-service/FirebaseFirestoreService";
import { useDispatch, useSelector } from "react-redux";
import dbQuestion from "../../data/data";
import { updateFormDataRedux } from "../../actions/formData.actions";
import { LoadingOne } from "../Loader/LoadingOne";
import { notify } from "../../services/toast-function";
import { ToastContainer } from "react-toastify";

export const BubbleUserActual = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [allowFinalize, setAllowFinalize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const formDataDic = useSelector((state) => {
    return state.formDataDic;
  });
  const user = useSelector((state) => {
    return state.user;
  });
  const [text, setText] = useState("");
  const handleChangeText = (e) => {
    setText(e.target.value);
  };
  const sendMessage = () => {
    if (text) {
      const idActual = formDataDic?.formData?.length;
      const questionActual = dbQuestion?.find((e) => e.id === idActual);

      const contentChatDic = {
        id: idActual,
        theme: questionActual.theme,
        question: questionActual.question,
        type: questionActual.type,
        answer: text,
      };
      const tabQA = [...formDataDic?.formData, contentChatDic];
      FirebaseFirestoreService.updateDocumentField(
        "formDataCollec",
        formDataDic?.id,
        tabQA
      )
        .then(() => {
          const queries = [
            {
              field: "uid",
              condition: "==",
              value: formDataDic.uid,
            },
          ];
          FirebaseFirestoreService.readDocuments({
            collectionName: "formDataCollec",
            queries: queries,
          })
            .then((data) => {
              setText("");
              dispatch(updateFormDataRedux(data[0]));
            })
            .catch((error) => {
              console.log("Message: ", error);
              return notify("Oops!Une erreur c'est produite, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");
            });
        })
        .catch((error) => {
          console.log("Message non envoyé: ", error);
          return notify("Oops!Une erreur c'est produite, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");
        });
    }
  };

  const handleChangeNumber = (e) => {
    setPhoneNumber(e.target.value);
    if (phoneNumber?.length > 5) {
      setAllowFinalize(true);
    } else {
      setAllowFinalize(false);
    }
  };

  const handleSubmit = () => {
    const tabForm = formDataDic?.formData.map(
      (e) => " question: " + e.question + " réponse: " + e.answer
    );
    setIsLoading(true);
    const stringForm = tabForm.join();
    if (stringForm && phoneNumber.length > 9) {
      fetch(`${process.env.REACT_APP_URL_API}/api/analyse/recommandation`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          textUser: stringForm,
          password: formDataDic?.uid,
          email: formDataDic?.email,
          phoneNumber: phoneNumber,
        }),
      })
      .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
      .then(() => {
        FirebaseFirestoreService.updateDocumentFieldIsSubmitted(
          "formDataCollec",
          formDataDic?.id
        )
          .then(() => {
            const queries = [
              {
                field: "uid",
                condition: "==",
                value: formDataDic.uid,
              },
            ];
            FirebaseFirestoreService.readDocuments({
              collectionName: "formDataCollec",
              queries: queries,
            })
              .then((data) => {
                setIsLoading(false);
                dispatch(updateFormDataRedux(data[0]));
              })
              .catch((error) => {
                setIsLoading(false);
                console.log("Message: ", error);
                return notify("Oops!Une erreur c'est produite, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");
              });
          })
          .catch((error) => {
            setIsLoading(false);
            console.log("Message non envoyé: ", error);
            return notify("Oops!Deux erreurs ce sont produites, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");
          });
      })
      .catch((error)=>{setIsLoading(false);
        console.log("Message non envoyé: ", error);
        return notify("Oops!Trois erreurs ce sont produites, reconnecter vous et si l'erreur se reproduit, envoyer nous un mail à agence.aykin@gmail.com", "error");});
        
    }
  };
  return (
    <div className="flex flex-col">
      <ToastContainer/>
      {isLoading ? (
        <LoadingOne />
      ) : (
        <div
          className="flex flex-col gap-2 justify-end items-end"
          id="newQuestion"
        >
          {formDataDic?.formData?.length < dbQuestion?.length ? (
            <div className="flex flex-col justify-start items-end w-full">
              <div className="chat-header pr-4">{user?.displayName}</div>
              <div className="w-full flex flex-row gap-2">
                <textarea
                  value={text}
                  onChange={handleChangeText}
                  className="chat-bubble bg-slate-100 text-black w-full border-black border-2"
                  placeholder="taper votre réponse ici..."
                ></textarea>
                <div className="chat-image avatar">
                  <div className="w-10 rounded-full">
                    <img alt="utilisateur" src={user?.photoURL} />
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="flex flex-col w-full items-end">
              <div className="chat-header pr-4">{user?.displayName}</div>
              <div className="chat chat-end w-full">
                <div className="chat-image avatar">
                  <div className="w-10 rounded-full">
                    <img alt="utilisateur" src={user?.photoURL} />
                  </div>
                </div>

                <label className="chat-bubble input-bordered flex items-center gap-2">
                  <img
                    alt="phone"
                    className="w-[24px]"
                    src="/icons/phone-svg.svg"
                  />
                  <input
                    type="text"
                    maxLength={20}
                    placeholder="Taper votre numéro..."
                    className="chat-bubble"
                    value={phoneNumber}
                    onChange={(e) => {
                      handleChangeNumber(e);
                    }}
                  />
                </label>
              </div>
            </div>
          )}
          <div className="flex flex-col w-full items-end pr-4">
            {formDataDic?.formData?.length < dbQuestion?.length && (
              <button
                className="btn btn-neutral btn-sm lg:btn-md w-[200px]"
                onClick={() => {
                  sendMessage();
                }}
              >
                <img alt="send" src="./icons/send.svg" />
                Envoyer
              </button>
            )}
            {allowFinalize && (
              <button
                className="btn btn-success text-white"
                onClick={() => {
                  handleSubmit();
                }}
              >
                Finaliser et traiter mes réponses
              </button>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
